export default __webpack_public_path__ + "static/media/honey_background.ec700b98.svg";